import React from 'react';
import { Modal } from '../AdminForm';
import { GenericFormProps } from './GenericFormTypes';
import { useFormValidation } from './useFormValidation';
import { getFieldGroupConfigs } from './FormFieldGrouping';
import { FormFieldGroup } from './FormFieldGroup';

/**
 * Generic Form Component (Refactored)
 * Main orchestrator for form functionality with modular structure
 */

export const GenericForm = <T,>({
  isOpen,
  onClose,
  title,
  data,
  fields,
  onFieldChange,
  onSave,
  saveText = 'Kaydet',
}: GenericFormProps<T>) => {
  // Initialize validation hook
  const { validationErrors, validateForm, clearValidationErrors, clearFieldError } =
    useFormValidation(data, fields);

  // Get field group configurations
  const fieldGroupConfigs = getFieldGroupConfigs(fields);

  // Handle save with validation
  const handleSave = () => {
    if (validateForm()) {
      onSave();
      clearValidationErrors();
    }
  };

  // Handle modal close
  const handleClose = () => {
    clearValidationErrors();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      onSave={handleSave}
      saveText={saveText}
      size="md"
    >
      <div className="space-y-5">
        {fieldGroupConfigs.map(config => (
          <FormFieldGroup
            key={config.category}
            config={config}
            data={data}
            onFieldChange={onFieldChange}
            validationErrors={validationErrors}
            onClearError={clearFieldError}
          />
        ))}
      </div>
    </Modal>
  );
};
